// React and related dependencies
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

// Components
import Main from './Main';
import Profile from "./Profile";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAt0nl1fHEDpIkN9LLCu5hKRFg1mMezqZs",
  authDomain: "lacoste-th-customer-dashboard.firebaseapp.com",
  projectId: "lacoste-th-customer-dashboard",
  storageBucket: "lacoste-th-customer-dashboard.firebasestorage.app",
  messagingSenderId: "402822980962",
  appId: "1:402822980962:web:872082539d1d1c8ac0783b",
  measurementId: "G-4GM4J3TEQ6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />}>
          <Route index element={<Profile />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
